import { ContentAttachments } from '@/components/widget/content-attachments';
import { ContentDescriptionEditable } from '@/components/widget/content-description-editable';
import { CANONICAL_LABELS } from '@/lib/content-labels';
import { Anchor } from '@vivport/backend/types';
import { ExternalLink } from 'lucide-react';

interface DetailsAnchorProps {
  content: Anchor;
  onDescriptionSave: (description: string) => Promise<void>;
  isRegenerating: boolean;
}

export function DetailsAnchor({ content: anchor_, onDescriptionSave, isRegenerating }: DetailsAnchorProps) {
  return (
    <div data-testid="details-anchor">
      {anchor_.driveFolder ? (
        <p className="mb-3 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
          <span>
            Folder: {anchor_.driveFolder.folderName} in {anchor_.driveFolder.driveName}
          </span>
          {anchor_.driveFolder.driveWebUrl ? (
            <a
              href={anchor_.driveFolder.driveWebUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 underline hover:text-foreground"
            >
              <ExternalLink className="h-3 w-3" />
              Open in SharePoint
            </a>
          ) : null}
          <span>
            {anchor_.driveFolder.titleFollowsFolder
              ? 'Title follows the folder name.'
              : 'Renamed in Vivport; folder renames no longer change the title.'}
          </span>
        </p>
      ) : null}
      <div className="flex flex-col gap-2">
        <h3 className="font-medium">Description</h3>
        <ContentDescriptionEditable
          description={anchor_.description || ''}
          onSave={onDescriptionSave}
          disabled={isRegenerating}
          placeholder={isRegenerating ? "Regeneration currently in progress" : "Click to add description"}
        />
      </div>

      <ContentAttachments
        parentContentId={anchor_.id}
        title="Attachments"
        emptyText="No attachments yet"
        breadcrumbLabel={CANONICAL_LABELS.anchor}
      />
    </div>
  );
}
